import React, { useState, useRef, useEffect } from 'react'
import { ScrollPanel } from 'primereact/components/scrollpanel/ScrollPanel'
import classNames from 'classnames'

// Layout
import Topbar from './TopBar/Topbar'
import Menu from './Menu/Menu'

const isDevelopMode = () => process.env.NODE_ENV === 'development'
const themeMenu = isDevelopMode()
  ? [
      {
        label: 'Tema SIGMA',
        icon: 'pi pi-fw pi-home',
        command: () =>
          window.open('https://www.primefaces.org/sigma-react/#/', '_blank')
      }
    ]
  : []
export const Admin = React.memo(props => {
  const [layoutMode] = useState('static')
  const [layoutColorMode] = useState('light')
  const [staticMenuInactive, setStaticMenuInactive] = useState(false)
  const [overlayMenuActive, setOverlayMenuActive] = useState(false)
  const [mobileMenuActive, setMobileMenuActive] = useState(false)

  const { history, children } = props

  const layoutMenuScroller = useRef(null)

  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className)
    else element.className += ' ' + className
  }

  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className)
    else {
      element.className = element.className.replace(
        new RegExp(
          '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
          'gi'
        ),
        ' '
      )
    }
  }

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, 'body-overflow-hidden')
    } else removeClass(document.body, 'body-overflow-hidden')
  })

  const menu = [
    ...themeMenu,
    {
      label: 'Home',
      icon: 'pi pi-fw pi-home',
      command: () => history.push('/')
    },
    {
      label: 'Concluir Denúncia',
      icon: 'pi pi-fw pi-images',
      command: () => history.push('/concluir-denuncia')
    }
  ]

  let menuClick

  const onWrapperClick = () => {
    if (!menuClick) {
      setOverlayMenuActive(false)
      setMobileMenuActive(false)
    }

    menuClick = false
  }

  const onToggleMenu = () => {
    menuClick = true

    if (window.innerWidth > 1024) {
      if (layoutMode === 'overlay') {
        setOverlayMenuActive(!overlayMenuActive)
      } else if (layoutMode === 'static') {
        setStaticMenuInactive(!staticMenuInactive)
      }
    } else {
      setMobileMenuActive(!mobileMenuActive)
    }
  }

  const onSidebarClick = () => {
    menuClick = true
    layoutMenuScroller.current.moveBar()
  }

  const onMenuItemClick = ({ item }) => {
    if (!item.items) {
      setOverlayMenuActive(false)
      setMobileMenuActive(false)
    }
  }

  const wrapperClass = classNames('layout-wrapper', {
    'layout-overlay': layoutMode === 'overlay',
    'layout-static': layoutMode === 'static',
    'layout-static-sidebar-inactive':
      staticMenuInactive && layoutMode === 'static',
    'layout-overlay-sidebar-active':
      overlayMenuActive && layoutMode === 'overlay',
    'layout-mobile-sidebar-active': mobileMenuActive
  })
  const sidebarClassName = classNames('layout-sidebar', {
    'layout-sidebar-dark': layoutColorMode === 'dark'
  })

  return (
    <div className={wrapperClass} onClick={onWrapperClick}>
      <Topbar {...props} onToggleMenu={onToggleMenu} />

      <div className={sidebarClassName} onClick={onSidebarClick}>
        <ScrollPanel ref={layoutMenuScroller} style={{ height: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              height: '100%'
            }}
          >
            <div className='layout-sidebar-scroll-content'>
              <div className='layout-logo'>
                <img
                  src='https://apidev2.eticca.app/0800/resources/logo.png'
                  alt='Eticca logo'
                />
              </div>
              <Menu model={menu} onMenuItemClick={onMenuItemClick} />
            </div>
            <p style={{ alignSelf: 'center', fontWeight: 'bold' }}>
              Versão: v0.0.12
            </p>
          </div>
        </ScrollPanel>
      </div>

      <div className='layout-main'>{children}</div>

      <div className='layout-mask' />
    </div>
  )
})
